import App from "./App.svelte";
import { quiz } from "./quiz/quiz";
import { result } from "./quiz/result";
let score = {
    sch: 0,
    grv: 0,
    img: 0,
    thr: 0,
    mas: 0,
    new: 0,
    hlf: 0,
    hub: 0,
    scw: 0,
};
const app = new App({
    target: document.body,
    props: {
        quiz: quiz,
        result: result,
        score: score,
    },
});
export default app;
